export function toShortIsoLocalDate(value) {
    const timestamp = value.getTime();
    if (!Number.isFinite(timestamp)) {
        throw new Error('Dates must be valid');
    }
    return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
}
